import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";
import { $Affix, $Empty, $PageHeader } from "us.common/components";
import { Formik } from "formik";
import "./Home.scss";
import { followUps } from "us.collection.followup/actions";
import {
  FollowUpList,
  FollowUpResult,
} from "us.collection.followup/components/FollowUps/Components";
import { DoubleRightOutlined, DoubleLeftOutlined } from "us.icons";
import { RootState } from "us.helper/types";
import {
  getFollowupName,
  isCommonFollowup,
  manageFilterSelection,
  getSelectedFilterName,
} from "./Components/FollowUpResult/Functions";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { SavedFiltersTabs } from "us.collection.followup/constants";
import _ from "lodash";

const { result, reImport, categoryId, reasons, caseHandlers } = followUps;

const FollowUpsHome: React.FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const { followUpId, filterId } =
    useParams<{ followUpId?: string; filterId?: string }>();
  const [menuopen, menuOpen] = useState<boolean>(false);
  const {
    categories,
    followUpNavigation,
    filters,
    list,
    result,
    filterAddRemoveInfo,
    getCategoryId,
    getFollowupReasons,
    getCaseHandlers,
  } = props;

  const { data: followupList } = list ?? {};
  const { followupId } = result ?? {};
  const { isBack } = followUpNavigation ?? {};
  const { selectedCategoryId, categorySearchText } = categories ?? {};
  const location = useLocation();
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState<string>("");
  const [followupSearch, setFollowupSearch] = useState<string>("");

  const isCommonFollowUp = useMemo(() => {
    return isCommonFollowup(list.data, followUpId);
  }, [list.data, followUpId]);

  useEffect(() => {
    if (!isBack) {
      getCategoryId && getCategoryId({ followUpId: followUpId ?? -1 });
    } else {
      setSearchText(filters.data?.searchText);
      setFollowupSearch(categorySearchText);
    }
    getCaseHandlers && getCaseHandlers({});
  }, []);

  useEffect(() => {
    setFollowupSearch(categorySearchText);
  }, [selectedCategoryId]);

  useEffect(() => {
    if (
      !isBack &&
      list.data?.length > 0 &&
      selectedCategoryId == -1 &&
      isCommonFollowUp
    ) {
      getFollowupReasons && getFollowupReasons({});
    }
  }, [list.data, followUpId, selectedCategoryId]);

  // Select Deselect filters after add or remove event
  useEffect(() => {
    if (!isBack) {
      manageFilterSelection(filterAddRemoveInfo, history, location);
    }
  }, [filterAddRemoveInfo]);

  const menuToggle = () => {
    menuOpen((prevCheck) => !prevCheck);
  };

  return (
    <Formik
      initialValues={{
        followUpCategory: selectedCategoryId,
        searchText,
        followupSearch,
        savedFilterTab: SavedFiltersTabs.ALL,
      }}
      onSubmit={() => {}}
      enableReinitialize
    >
      {({ values }: any) => (
        <>
          <div className="followup-list">
            <$Affix offsetTop={48}>
              <div className="page-header">
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <div className="d-flex flex-row align-items-center">
                    <$PageHeader
                      style={{
                        minWidth: "120px",
                      }}
                      className="px-0"
                      title={t("US.COLLECTION.FOLLOWUP:FOLLOWUP_HOME.FOLLOWUP")}
                      onBack={() => navigate("/")}
                    />
                    {followupId != -1 && (
                      <div className="flc-count mr-5 ml-5">
                        <span className="bui-label">
                          {t(
                            "US.COLLECTION.FOLLOWUP:FOLLOWUP_HOME.CURRENTLY_VIEWING"
                          )}
                          {" : "}{" "}
                          {!filterId &&
                            getFollowupName(followupList, followupId)}
                          {filterId &&
                            getSelectedFilterName(followupList, filterId)}
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="ml-5"></div>
                </div>
              </div>
            </$Affix>
            <div
              className={
                menuopen
                  ? "followup-list-wrap fl-menu-open"
                  : "followup-list-wrap"
              }
            >
              <FollowUpList {...props} categoryId={values.followUpCategory} />
              {followUpId === undefined && (
                <div className="fl-container">
                  <div className="flc-body">
                    <div className="followup-dashboard-msg">
                      <$Empty className="pt-5" description={false} />
                      <div className="fdm-popover ant-popover ant-popover-placement-right">
                        <div className="ant-popover-content">
                          <div className="ant-popover-arrow">
                            <span className="ant-popover-arrow-content"></span>
                          </div>
                          <div className="ant-popover-inner" role="tooltip">
                            <div className="ant-popover-inner-content">
                              <div>
                                <p className="my-4 px-5">
                                  {t(
                                    "US.COLLECTION.FOLLOWUP:FOLLOWUP_HOME.PLEASE_SELECT_A_"
                                  )}
                                  <strong>
                                    {t(
                                      "US.COLLECTION.FOLLOWUP:FOLLOWUP_HOME.FOLLOWUP"
                                    )}
                                  </strong>
                                  {t(
                                    "US.COLLECTION.FOLLOWUP:FOLLOWUP_HOME._FROM_THE_LIST"
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {followUpId !== undefined && (
                <>
                  <div className="fl-sidebar-toggle">
                    <div
                      className="fl-sidebar-toggle-btn"
                      onClick={() => menuToggle()}
                    >
                      {menuopen && <DoubleRightOutlined />}
                      {!menuopen && <DoubleLeftOutlined />}
                    </div>
                  </div>
                  <FollowUpResult {...props} />
                </>
              )}
            </div>
          </div>
        </>
      )}
    </Formik>
  );
};

const mapStateToProps = (state: RootState) => {
  const { followUps } = state;
  const {
    categories,
    filters,
    followUpNavigation,
    result,
    list,
    filterAddRemoveInfo,
  } = followUps;
  return {
    categories,
    filters,
    followUpNavigation,
    result,
    list,
    filterAddRemoveInfo,
  };
};

const mapDispatchToProps = {
  getFollowUpResult: result.get,
  reImportFollowUp: reImport.execute,
  getCategoryId: categoryId.get,
  getFollowupReasons: reasons.get,
  getCaseHandlers: caseHandlers.get,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(FollowUpsHome);
